import operationsPalettes from '@core/constants/palettes';
import { contrastPalettes } from '@screens/Map/components/Overlays/MapControlsOverlay/MapControls/Palette/contrast';
import type { ImageType } from '../metadata';

type UserRole = 'ADMIN' | 'USER';

interface OptIn {
  id: string;
  type: string;
  accepted_on: Date;
}

export interface BaseUser {
  id: string;
  initials: string;
  name: string;
  login: string;
  email?: string;
  type: string;
  ssn: any | null;
  job_title: string | null;
  role: UserRole;
  phone: string;
  locale: string;
  clock_format: string;
  tutorial_complete: boolean;
  pending_change_password: boolean;
  licensing_accounts: any | null;
  auto_created_org_id?: string;
  default_licensing_account_id: string;
  default_workspace_id?: string;
  opt_ins: Array<OptIn>;
  country_code?: string;
}

export interface ColorsEntity {
  color?: string;
  end: number;
  start: number;
  rate?: number | null;
  total?: number;
  percentage?: number;
  area?: number;
  descriptionKey?: string;
}

export interface ColorMaps {
  name: string;
  clip: Clip;
  colors: ColorsEntity[];
}

export interface Clip {
  max: number;
  min: number;
}

export interface UserPreferences {
  contrastPalette: ColorMaps;
  selectedColorMap: ColorMaps;
  selectedIndex: ImageType;
  colorMaps: ColorMaps[];
}

export interface MapFieldOrIssue {
  fill_color: string;
  fill_opacity: number;
  stroke_color: string;
  stroke_opacity: number;
}

export const emptyUserPreferences: UserPreferences = {
  contrastPalette:
    contrastPalettes.find((c) => c.name === localStorage.getItem('selectedContrastPalette')) ??
    contrastPalettes[0],
  colorMaps: operationsPalettes,
  selectedColorMap: operationsPalettes[0],
  selectedIndex: 'ndvi',
};
